import {
  RouteShellContextProvider,
  resolveRouteShellState,
  useRouteShellPathname,
} from "@components/routeShellContext"
import type { SiteShellProps } from "@site-types/components/siteShell"
import BackButtonComponent from "./BackButton"
import Background from "./Background"
import BigHeadingComponent from "./BigHeading"
import Footer from "./Footer"
import Main from "./Main"
import SideMenu from "./SideMenu"

export function SiteShell({ children, page, title }: SiteShellProps) {
  const pathname = useRouteShellPathname()
  const shellState = resolveRouteShellState({ page, pathname })

  const content = (
    <>
      {title ? <BigHeadingComponent>{title}</BigHeadingComponent> : null}
      {children}
    </>
  )

  return (
    <RouteShellContextProvider
      page={page}
      pathname={pathname}
    >
      <div className="relative flow-root min-h-[100dvh]">
        <SideMenu />
        <Main>
          {shellState.currentPage === "index" ? (
            content
          ) : (
            <div
              data-page={shellState.pageClass}
              className={`m-0 max-w-none p-0 ${
                ["calendar", "careers", "company", "work"].includes(shellState.pageClass)
                  ? "max-page:p-0"
                  : "max-page:px-[2rem] max-page:pt-[5rem] max-page:pb-[3rem]"
              }`}
            >
              {content}
            </div>
          )}
          {shellState.currentPage !== "index" ? <Footer /> : null}
        </Main>
        <Background />
      </div>
    </RouteShellContextProvider>
  )
}

export const BigHeading = BigHeadingComponent

export const BackButton = BackButtonComponent
